export default class CmsApi {
	/**
	 *
	 * @return {Promise<Array<Place>>}
	 */
	static fetchPlaces() {
		return fetch('/api/places').then(rs => rs.json());
	}

}
